import { useSelector } from "react-redux";
import Product from "./Product";
import getSymbolFromCurrency from "currency-symbol-map";
import EstimatedDeliveryDate from "../EstimatedDeliveryDate";

const ProductList = ({ order }) => {
  const { line_items: products, subtotal_price: totalPrice, currency } = order;
  const { order_details: i18n } = useSelector((state) => state.i18n);
  const { enabled_edd } = useSelector((state) => state.featureSetting);

  const lineItems =
    typeof products === "string"
      ? JSON.parse(products).filter((item) => item.product_id !== null)
      : products.filter((item) => item.product_id !== null);
  return (
    <>
      {enabled_edd == "1" && (
        <div className="omg-section-shipment-info omg-edd-date-bs">
          <EstimatedDeliveryDate order={order} />
        </div>
      )}
      <div className="omg-section-shipment-info">
        <div className="omg-section">
          <div className="omg-section__title">{i18n?.shipment_items}</div>
          <div className="omg-section__content">
            <div className="omg-list">
              <div className="omg-prod-lineitems">
                {lineItems.length &&
                  lineItems?.map((product, index) => (
                    <Product key={index} value={product} currency={currency} />
                  ))}
              </div>
              <div className="omg-list__footer">
                <div className="omg-total-price">
                  <div className="omg-total-price__title">
                    {i18n?.total_price}
                  </div>
                  <div className="omg-total-price__value">
                    {getSymbolFromCurrency(currency)}
                    {totalPrice}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductList;
